import { render, staticRenderFns } from "./boletinsiisa.vue?vue&type=template&id=247d99f0"
import script from "./boletinsiisa.vue?vue&type=script&lang=js"
export * from "./boletinsiisa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports